import { lazy } from 'react';

export default lazy(() =>
  import(/* webpackChunkName: 'reset_password' */ './ResetPassword'),
);
